export default "__VITE_ASSET__Fg_5JMwU__"